/**
 * Showcase block — YouTube video player.
 * Event delegation: one listener handles all .showcase__play buttons on the page.
 */
const ShowcaseVideo = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.showcase__play');
    if (!btn) return;

    const wrapper = btn.closest('.showcase__video');
    if (!wrapper || wrapper.classList.contains('is-playing')) return;

    const ytId = wrapper.getAttribute('data-youtube-id');
    const template = wrapper.querySelector('.showcase__custom-iframe');

    if (ytId) {
      const iframe = document.createElement('iframe');
      iframe.src          = `https://www.youtube.com/embed/${encodeURIComponent(ytId)}?autoplay=1&rel=0`;
      iframe.title        = 'YouTube video player';
      iframe.allow        = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('loading', 'lazy');
  
      wrapper.appendChild(iframe);
      wrapper.classList.add('is-playing');
    } else if (template) {
      wrapper.appendChild(template.content.cloneNode(true));
      
      // Try to append autoplay parameter if it is an iframe
      const iframe = wrapper.querySelector('iframe');
      if (iframe && iframe.src) {
        if (iframe.src.includes('?')) {
          iframe.src += '&autoplay=1';
        } else {
          iframe.src += '?autoplay=1';
        }
      }
      
      wrapper.classList.add('is-playing');
    }
  });
};

export default ShowcaseVideo;
